import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-brands",
  "use": "google-brands-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"google-brands\"><path d=\"M23.806 12.28c0 6.847-4.688 11.72-11.613 11.72-6.638 0-12-5.361-12-12s5.362-12 12-12c3.233 0 5.952 1.185 8.047 3.14l-3.266 3.14C12.702 2.159 4.756 5.256 4.756 12c0 4.186 3.344 7.577 7.438 7.577 4.751 0 6.532-3.406 6.812-5.172h-6.813v-4.128h11.425c.111.615.188 1.205.188 2.004z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol